import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { withStyles, styled } from "@material-ui/styles";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Link, useHistory, useParams, useLocation } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import Checkbox from "@mui/material/Checkbox";

// adding styles to text field input
const styles = (theme) => ({
  input: {
    height: 40,
  },
  previewChip: {
    minWidth: 160,
    maxWidth: 210,
  },
});

const AddCompany = withStyles(styles)((props) => {
  
  // getting logged in user info
  const userLogin = useSelector((state) => state.userLogin);
  const { error, loading, userInfo } = userLogin;
  const { classes } = props;
  // state for handling step count
  const [activeStep, setActiveStep] = useState(0);
  const history = useHistory();
  const location = useLocation(); 

  // function to go to next step
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  // function to go to previous step
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  //function to reste all the step count
  const handleReset = () => {
    setActiveStep(0);
  };

  //go back function to route to the previous page when the button is clicked
  const goBack = () => {
    history.goBack();
  };

  return (
    <div>
      <Button variant="contained" onClick={goBack}>
        Go Back
      </Button>{" "}
      <br />
      <div style={{ fontSize: "1.3rem", marginTop: "1rem" }}>Add company</div>
      <Box
        sx={{ maxWidth: "100%" }}
        style={{
          margin: "1.5rem 0.5rem 2.5rem 0.5rem",
          backgroundColor: "white",
          boxShadow:
            "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
        }}
      >
        <form>
          <Stepper
            activeStep={activeStep}
            orientation="vertical"
            style={{ padding: "1rem 2rem" }}
          >
            <Step>
              <StepLabel>
                <span style={{ fontSize: "1.2rem" }}>Company details</span>
              </StepLabel>
              <StepContent>
                <Grid container spacing={2} style={{ margin: "1.2rem 0" }}>
                  <Grid item xs={12} md={6}>
                    <div>Company Name</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Company Name"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>Entity Name</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Entity Name"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>Email</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Company email"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>Website</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Website"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>Phone number</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Phone number"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>Fax number</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Fax number"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>Type</div>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Age"
                      fullWidth
                      input={<OutlinedInput />}
                      size="small"
                      value="General"
                    >
                      <MenuItem value={"General"}>General</MenuItem>
                      <MenuItem value={"Retail"}>Retail</MenuItem>
                      <MenuItem value={"Customer"}>Customer</MenuItem>
                      <MenuItem value={"Supplier"}>Supplier</MenuItem>
                      <MenuItem value={"Wholesale"}>Wholesale</MenuItem>
                      <MenuItem value={"Restaurants"}>Wholesale</MenuItem>
                      <MenuItem value={"Online"}>Online</MenuItem>
                      <MenuItem value={"Distributor"}>Distributor</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div style={{ marginTop: "1.2rem" }}>
                      <Checkbox />{" "}
                      <span style={{ marginTop: "0.2rem" }}>In Dispute</span>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>Identifier / Code</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Identifier / Code"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                </Grid>

                <Box sx={{ mb: 2 }}>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Next
                    </Button>
                  </div>
                </Box>
              </StepContent>
            </Step>
            <Step>
              <StepLabel>
                <span style={{ fontSize: "1.2rem" }}> Company address</span>
              </StepLabel>
              <StepContent>
                <Grid container spacing={2} style={{ margin: "1.2rem 0" }}>
                  <Grid item xs={12} md={6}>
                    <div>Address</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Address"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>Address 2</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Address"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>City</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="City"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>State</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="State"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>Country</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Country"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div>Post code</div>
                    <TextField
                      id="outlined-basic"
                      placeholder="Post code"
                      fullWidth
                      InputProps={{
                        className: classes.input,
                      }}
                      required={false}
                      variant="outlined"
                      value=""
                    />
                  </Grid>
                </Grid>

                <Box sx={{ mb: 2 }}>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Next
                    </Button>
                  </div>
                </Box>
              </StepContent>
            </Step>
            <Step>
              <StepLabel>
                <span style={{ fontSize: "1.2rem" }}>Primary contact</span>
              </StepLabel>
              <StepContent>
                <Grid container spacing={2} style={{ margin: "1.2rem 0" }}>
                  <Grid item xs={12} md={12}>
                    <div>Type contact name</div>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="Type contact name"
                      placeholder="Type contact name"
                      fullWidth
                      input={<OutlinedInput />}
                      size="small"
                    >
                      <MenuItem value={"Single"}>Single</MenuItem>
                      <MenuItem value={"Married"}>Married</MenuItem>
                      <MenuItem value={"Divorced"}>Divorced</MenuItem>
                      <MenuItem value={"Defacto"}>Defacto</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    Can't find the contact?{" "}
                    <Button
                      variant="contained"
                      style={{ textTransform: "none", fontWeight: "500" }}
                      startIcon={<AddIcon />}
                    >
                      Add Contact
                    </Button>
                  </Grid>
                </Grid>

                <Box sx={{ mb: 2 }}>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Back
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      onClick={handleNext}
                      sx={{ mt: 1, mr: 1 }}
                    >
                      Finalise
                    </Button>
                  </div>
                </Box>
              </StepContent>
            </Step>
          </Stepper>
        </form>
        {/* {activeStep === 3 && (
        <Paper square elevation={0} sx={{ p: 3 }}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
            Reset
          </Button>
        </Paper>
      )} */}
      </Box>
    </div>
  );
});

export default AddCompany;

// <Box sx={{ maxWidth: "100%" }}>
// <Stepper activeStep={activeStep} orientation="vertical">
//   {steps.map((step, index) => (
//     <Step key={step.label}>
//       <StepLabel
//         optional={
//           index === 3 ? (
//             <Typography variant="caption">Last step</Typography>
//           ) : null
//         }
//       >
//         {step.label}
//       </StepLabel>
//       <StepContent>
//         <Typography>{step.description}</Typography>
//         <Box sx={{ mb: 2 }}>
//           <div>
//             <Button
//               disabled={index === 0}
//               onClick={handleBack}
//               sx={{ mt: 1, mr: 1 }}
//             >
//               Back
//             </Button>
//             <Button
//               variant="contained"
//               onClick={handleNext}
//               sx={{ mt: 1, mr: 1 }}
//             >
//               {index === steps.length - 1 ? "Finish" : "Next"}
//             </Button>
//           </div>
//         </Box>
//       </StepContent>
//     </Step>
//   ))}
// </Stepper>
// {activeStep === steps.length && (
//   <Paper square elevation={0} sx={{ p: 3 }}>
//     <Typography>All steps completed - you&apos;re finished</Typography>
//     <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
//       Reset
//     </Button>
//   </Paper>
// )}
// </Box>
